import styled from 'styled-components';

export const Border = styled.div`
  width: 94px;
  margin: auto;
  position: relative;
  padding: 20px;
  z-index: 1;
  border-bottom: 5px solid #0091da;
`;
